var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 126,
    viewBox: "0 0 106 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    clipPath: "url(#clip0_815_14576)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.394 123.932L96.0635 15.3951L70.7724 1.125H1.20312L10.6591 123.932H104.394Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.391 125.057H10.6568C10.0314 125.057 9.48103 124.588 9.45602 124.002L0 1.21847C0 0.913849 0.100064 0.585801 0.325207 0.35148C0.55035 0.11716 0.875557 0 1.20076 0H70.77C70.9952 0 71.1953 0.046864 71.3954 0.164024L96.6865 14.4107C97.0368 14.5982 97.2369 14.9262 97.2619 15.3011L105.617 123.838C105.617 124.143 105.517 124.471 105.292 124.705C105.067 124.94 104.742 125.057 104.416 125.057H104.391ZM11.7825 122.784H103.091L94.8854 16.0509L70.4198 2.27291H2.52661L11.7825 122.784Z",
    fill: "#002E68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0567 15.3951L70.7656 1.125L80.0465 20.0112L96.0567 15.3951Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0475 21.1605C79.5972 21.1605 79.1469 20.9027 78.9468 20.5044L69.6659 1.61818C69.4407 1.17298 69.5658 0.634039 69.9661 0.30599C70.3663 -0.0220579 70.9417 -0.068922 71.392 0.18883L96.6831 14.4355C97.0833 14.6698 97.3085 15.0916 97.2584 15.5368C97.2084 15.982 96.8582 16.3569 96.4079 16.4741L80.3977 21.1136C80.3977 21.1136 80.1475 21.1605 80.0475 21.1605ZM73.5183 4.00825L80.7229 18.6298L93.1308 15.0447L73.5183 4.00825Z",
    fill: "#002E68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4537 56.4481C40.6539 59.1896 38.4525 61.4156 35.5506 61.4156C32.6488 61.4156 30.0721 59.1896 29.872 56.4481C29.6719 53.7065 31.8733 51.4805 34.7751 51.4805C37.677 51.4805 40.2536 53.7065 40.4537 56.4481Z",
    fill: "#002E68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8287 56.4481C75.0289 59.1896 72.8275 61.4156 69.9256 61.4156C67.0238 61.4156 64.4471 59.1896 64.247 56.4481C64.0469 53.7065 66.2483 51.4805 69.1501 51.4805C72.052 51.4805 74.6286 53.7065 74.8287 56.4481Z",
    fill: "#002E68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_815_14576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.617,
    height: 125.057,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoForms);
export default __webpack_public_path__ + "static/media/no-forms.6a34983654ce0cb5603340550598f972.svg";
export { ForwardRef as ReactComponent };